import { Product } from 'shared/types/product/Product';
import ProductDetailsAdapter from 'components/gruenland/organisms/product-details/helpers/adapter';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';

const YggdrasilPDPTastic = ({ data, categories }: TasticProps<DataSource<{ product: Product }>>) => {
  const product = data?.data?.dataSource?.product;
  if (!product) return null;

  const category = categories.find((category) => product.categories?.find((c) => c.slug === category.slug));

  return <ProductDetailsAdapter product={product} category={category} />;
};

export default YggdrasilPDPTastic;
